import React, { useState, useEffect,  } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios'

const Checkout = () => {
  const [post, setPost] = useState(null)
  const { carrito } = useParams();
  const cartItems = JSON.parse(decodeURIComponent(carrito));
  const baseURL = `${import.meta.env.VITE_IP}/recibo`


  useEffect(() => {
    const sendPostRequest = async () => {
      try {
        const response = await axios.post(baseURL, {
          cartItems: cartItems,
        });
        setPost(response.data);
       // window.print()
       //imprimirCodigoHTML()
      } catch (err) {
        console.error(err);
      }
    };
    imprimirRecibo()
  }, []);



  const getTotal = () => {
    let total = 0;
    cartItems.map((item) => {
      !item.domicilio && !item.para ? (total += item.quantity * item.price) : null;
    });
    return total;
  };

  function imprimirRecibo() {
    const reciboHTML = `
    <div>
    <style>
      * {
        font-family: "Courier New", Courier, monospace;
        font-size: 12px;
      }
      .recibo {
        border: 1px solid #ccc;
        margin: 0;
        padding: 10px;
        max-width: 50mm;
      }
      .recibo header {
        text-align: center;
        margin-bottom: 10px;
      }
      .recibo ul.productos {
        list-style: none;
        margin: 0;
        padding: 0;
      }
      .recibo ul.productos li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 3px;
      }
      .recibo .total {
        display: flex;
        justify-content: space-between;
        font-weight: bold;
        margin-top: 5px;
        margin-bottom: 10px;
      }
      .recibo .domicilio {
        margin-top: 10px;
        border-top: 1px solid #ccc;
        padding-top: 5px;
      }
      .recibo .domicilio p {
        margin-bottom: 5px;
      }
    </style>
    <div class="recibo">
      <header>
        <h3>Pedido</h3>
      </header>
      <main>
        <ul class="productos">
          ${cartItems
            .map(
              (item) =>
                `<li>${item.quantity} ${item.name}</li>`
            )
            .join('')}
        </ul>
        <br />
        <br />
        <p class="total">
          Total: <span class="precio">${getTotal().toLocaleString()}</span>
        </p>
      </main>
      <footer>
        <p>
          <b>Hora:</b> ${formattedTime}
        </p>
        ${cartItems
          .filter((item) => item.para)
          .map(
            (item) =>
              `<p><b>Para:</b> ${item.para.value}</p>`
          )
          .join('')}
      </footer>
      ${cartItems
        .filter((item) => item.domicilio)
        .map(
          (item) =>
            `<div class="domicilio">
              <p><b>Domicilio:</b></p>
              <p>${item.domicilio.message}</p> 
            </div>`
        )
        .join('')}
    </div>
  </div>  
    `;
  
    const ventana = window.open('', '', 'height=500,width=500');
    ventana.document.write(reciboHTML);
    ventana.print();
    ventana.close();
  }
  
  const now = new Date();
  const formattedTime = now.toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });

  return (
    <div>
      <div className="recibo">
        <header>
            <h3>Pedido</h3>
        </header>
        <main>
          <ul className="productos">
            {cartItems.map(item => {
              return (
                <li>
                  {item.quantity} {item.name}
                </li>
              );
            })}
          </ul>
          <br />
          <br />
          <p className="total">
            Total: <span className="precio">${getTotal().toLocaleString()}</span>
          </p>
        </main>
        <footer>
          <p>
            <b>Hora:</b> {formattedTime}
          </p>
          {cartItems.map((item) => !item.para ? (<></>):(         
          <p>
            <b>Para:</b> {item.para.value}
          </p>))}
        </footer>
        {cartItems.map((item) => !item.domicilio ? (<></>):(
                  <div className="domicilio">
                  <p>
                    <b>Domicilio:</b>
                  </p>
                  <p>{item.domicilio.message}</p> 
                </div>
        ))}
      </div>
    </div>
  );
};


export default Checkout;
